import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { User } from '@core/interfaces/user.interface';
import { loadSlim } from '@tsparticles/slim';
import { Engine } from '@tsparticles/engine';
import { NgParticlesService, NgxParticlesModule } from '@tsparticles/angular';
import { ISourceOptions } from '@tsparticles/engine';
import { SvgIconComponent } from 'angular-svg-icon';
import { SessionService } from '@core/services/session.service';
import { LoginButtonComponent } from '@core/components/login-button/login-button.component';
import { UserLevelBarComponent } from '@core/components/user-level-bar/user-level-bar.component';
import { getHSLAByLevel, getHSLByLevel } from '@core/utils/colors.util';

@Component({
  selector: 'app-home-user-banner',
  imports: [
    SvgIconComponent,
    NgxParticlesModule,
    LoginButtonComponent,
    UserLevelBarComponent,
  ],
  templateUrl: './home-user-banner.component.html',
  styleUrl: './home-user-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'flex flex-col rounded-6',
    '[style.--current-color]': 'colors().currentColor',
    '[style.--current-bg-color]': 'colors().currentBgColor',
  },
})
export class HomeUserBannerComponent {
  user = input.required<User | null>();

  particlesOptions: ISourceOptions = {
    fullScreen: { enable: false },
    particles: {
      number: {
        value: 10,
      },
      color: {
        value: ['#ffffff'],
      },
      move: {
        direction: 'none',
        enable: true,
        outModes: {
          default: 'out',
        },
        random: true,
        speed: 1.25,
        straight: false,
      },
      opacity: {
        value: { min: 0.15, max: 0.69 },
      },
      size: {
        value: { min: 1, max: 1.2 },
      },
      wobble: {
        enable: false,
      },
    },
  };

  colors = computed(() => {
    const currentLevel = this.user()?.level ?? 0;

    return {
      currentColor: currentLevel
        ? getHSLByLevel(currentLevel)
        : 'var(--yellow)',
      currentBgColor: currentLevel
        ? getHSLAByLevel(currentLevel, 0.6)
        : 'var(--yellow-59)',
    };
  });

  constructor(
    private ngParticlesService: NgParticlesService,
    public sessionService: SessionService
  ) {}

  ngOnInit() {
    this.ngParticlesService.init(async (engine: Engine) => {
      await loadSlim(engine);
    });
  }
}
